import { Alert, Chip, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function PreviewBanner({ children }: { children: ReactNode }) {
  return (
    <Alert severity="info" variant="outlined" icon={false} sx={{ bgcolor: "#fff", py: 0.25 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Chip size="small" label="PRATINJAU" sx={{ bgcolor: "#f3e9d2", color: "#5c4316", fontWeight: 800 }} />
        <Typography variant="body2">{children}</Typography>
      </Stack>
    </Alert>
  );
}
